import React, { useEffect, useState } from 'react'
import Mynav from '../../components/Header/Header'
import { Container, Col, Row } from 'react-bootstrap'
import axios from 'axios'
import SpinnerComponents from '../../components/Spinner/SpinnerComponents'
import PaginationComponent from '../../components/Pagination/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { editPost, fetchShows } from '../../redux/actions/showsactions'
import { Link } from 'react-router-dom'
import { fetchMovies } from '../../redux/actions/moviesactions'
import './Movies.css'

const Movies = () => {
  const shows = useSelector(state => state.movies)

  let totalItems;
  let totalPages;
  let currentItems = [];
  
  const [category, setCategory] = useState([])
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 12;

  const dispatch = useDispatch()
  
  useEffect(() => {
    setLoading(true)
    dispatch(fetchMovies())
  }, [dispatch])
  
  useEffect(() => {
    console.log('Movies state updated:', shows)
    if (shows && shows.movies) {
      // Check if movies has results array (API response structure)
      if (shows.movies.results && Array.isArray(shows.movies.results) && shows.movies.results.length > 0) {
        console.log('Found movies.results:', shows.movies.results.length)
        setData(shows.movies.results)
        setLoading(false)
      } else if (Array.isArray(shows.movies) && shows.movies.length > 0) {
        // Fallback if movies is directly an array
        console.log('Found movies array:', shows.movies.length)
        setData(shows.movies)
        setLoading(false)
      } else if (shows.movies.results && Array.isArray(shows.movies.results)) {
        // Empty results array
        console.log('Empty results array')
        setData([])
        setLoading(false)
      } else {
        console.log('Movies structure:', shows.movies)
        setLoading(false)
      }
    } else if (shows && shows.loading === false && !shows.movies) {
      // Data loaded but no movies
      setData([])
      setLoading(false)
    }
  }, [shows])

  // Calculate pagination
  if (data && data.length > 0) {
    totalItems = data.length;
    totalPages = Math.ceil(totalItems / itemsPerPage);
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="movies-page">
      <Container className="px-2 px-md-3">
        {/* Page Header */}
        <div className="movies-header">
          <h6 className="movies-subtitle">Browse Our Collection</h6>
          <h1 className="movies-title">African Movies & Shows</h1>
          <p className="movies-description">
            Discover the latest African movies and entertainment content
          </p>
        </div>

        {/* Loading State */}
        {(shows?.loading || loading) && (
          <div className="movies-loading">
            <SpinnerComponents />
          </div>
        )}

        {/* Movies Grid */}
        {!(shows?.loading || loading) && data && data.length > 0 ? (
          <>
            <Row className="movies-grid">
              {currentItems.map(item => (
                <Col xs={6} sm={4} md={3} lg={2} xl={2} key={item.id} className="movie-col">
                  <div className="movie-card-page">
                    <div className="movie-image-wrapper">
                      <img 
                        src={item.Image} 
                        className="movie-image" 
                        alt={item.title}
                        loading="lazy"
                      />
                      <div className="movie-overlay-page">
                        <div className="play-icon-page">▶</div>
                      </div>
                    </div>
                    <h6 className="movie-title-page">{item.title}</h6>
                  </div>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="movies-pagination">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : !(shows?.loading || loading) && (
          <div className="movies-empty">
            <p>No movies available at the moment.</p>
            <p style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', marginTop: '1rem'}}>
              {shows && shows.movies ? `State: ${JSON.stringify(Object.keys(shows.movies))}` : 'Loading...'}
            </p>
          </div>
        )}
      </Container>
    </div>
  )
}

export default Movies
